module.exports = __webpack_public_path__ + "static/media/marlena-kiryk.fb24dcc7.jpg";